<!--
 * @Description: 管理员账号管理  企业管理员列表
 * @Autor: lwq
 * @Date: 2020-07-16 21:12:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-26 09:44:33
 * @FilePath: \mrc-base-server-view\src\views\admin_account_manage\index.vue
-->
<template>
  <div>
    <!-- 'clients_uuid','manager_type' -->
    <mrc_ess_table :headers="headers"
                   :hideAddBtn="!hasBtn('add-corporate-administrator')"
                   v-if="$route.name == 'admin_account_manage'"
                   pageName="admin_account_add"
                   :paginationOptions="paginationOptions"
                   @turnPage="getList"
                   :slotKey="['org_level_uuid',  'status']"
                   :isLoading="loading"
                   :items="items">
      <template v-slot:search>
        <v-row class="d-flex justify-end"
               style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4"
                                               v-model="systemSeniorQueryString"
                                               @success="getList({ cpage: 1 })"
                                               :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.manager_type="{ item }">
        {{ INT(item.manager_type) }}
      </template>
      <template v-slot:item.clients_uuid="{ item }">
        <div class="d-flex align-center">
          <!-- {{item.clients_uuid.length}} -->
          <div v-show="item.clients_uuid && item.clients_uuid.length > 0">
            <template v-for="(it, index) in splitINT(item.clients_uuid)">
              <mrc_ess_chip :key="index"
                            small
                            class="mr-1 my-1">
                {{ INT(it) }}
              </mrc_ess_chip>
            </template>
          </div>
          <!-- <span>（others）</span> -->
        </div>
        <span v-show="item.clients_uuid && item.clients_uuid.length <= 0"></span>
      </template>
      <template v-slot:item.org_level_uuid="{ item }">
        <template v-for="(it, index) in splitINT(item.org_level_uuid)">
          <mrc_ess_chip :key="index"
                        class="mr-1 my-1"
                        small>
            {{ INT(it) }}
          </mrc_ess_chip>
        </template>
        <span v-show="item.org_level_uuid && item.org_level_uuid.length <= 0"></span>
      </template>
      <template v-slot:item.status="{ item }">
        <mrc_ess_viewbtn :label="item.status"
                         :is_used="item.status_save_value"></mrc_ess_viewbtn>
        <!-- <span class="status"
              :class="{'is_used': !item.status}">{{item.status ? $t('label_Working') : $t('label_Frozen')}}</span> -->
      </template>
      <template v-slot:item.actions="{ item }">
        <menu-list :list="[
            {
              name: $t('label_View'),
              type: 'view',
              show: hasBtn('view-corporate-administrator'),
            },
            {
              name: $t('label_Edit'),
              type: 'edit',
              show: hasBtn('edit-corporate-administrator'),
            },
            {
              name: $t('label_To_reset_your_password'),
              type: 'resetPassword',
              show: hasBtn('reset-corporate-administrator-password'),
            },
            {
              name: $t('label_delete'),
              type: 'del',
              show: hasBtn('delete-corporate-administrator'),
            },
          ]"
                   @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
                'view-corporate-administrator',
                'edit-corporate-administrator',
                'reset-corporate-administrator',
                'delete-corporate-administrator',
              ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import {
  admin_account_list,
  admin_account_del,
} from "@/service/api/admin_account_manage"
import { mrc_admin_reset } from "@/service/api/mrc_system_admin"
export default {
  components: {},
  props: {},
  data () {
    return {
      systemSeniorQueryString: [],
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      loading: false,
      items: [],
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  validations: {},
  computed: {
    headers () {
      return [
        {
          text: this.$t("label_The_login_name"),
          value: "user_account",
        },
        // {
        //   text: this.$t("label_associated_customers"),
        //   value: "clients_uuid",
        // },
        {
          text: this.$t("label_Associated_with_the_unit"),
          value: "org_level_uuid",
        },
        // {
        //   text: this.$t("label_manager_type"),
        //   value: "manager_type",
        // },
        {
          text: this.$t("label_state"),
          value: "status",
        },
        {
          text: "",
          align: "end",
          value: "actions",
        },
      ]
    },
  },
  beforeCreate () {
    this.$store.commit("setCpage", 1)
  },

  async created () {
    await this.getBtnPermissionList()
  },
  watch: {
    async $route (val) {
      if (val.name == "admin_account_manage") {
        await this.getList(this.paginationOptions)
        this.$store.commit("setTab", 0)
      }
    },
  },
  async mounted () {
    await this.getList(this.paginationOptions)
  },
  beforeDestroy () { },
  methods: {
    /**
     * @description: 点击menulist的事件
     * @param {type}
     * @return:
     * @author: lwq
     */
    async handleClick ({ item, index }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_subPage_name", obj.user_account)

        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "admin_account_detail",
          params: {
            uuid: obj.uuid,
            name: obj.user_account,
          },
        })
      }
      if (item.type == "edit") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_subPage_name", obj.user_account)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "admin_account_detail",
          params: {
            uuid: obj.uuid,
            name: obj.user_account,
          },
        })
      }

      if (item.type == "del") {
        this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
          .then(async () => {
            if (obj.user_account == this.$store.state.userData.user_account) {
              this.$Message({
                text: this.$t("message_cannot_delete_own_account"),
              })
              return
            }
            const del = await admin_account_del({ uuid: obj.uuid })
            if (del.code == 200) {
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
              if (this.paginationOptions.cpage > 1 && this.items.length == 1) {
                this.paginationOptions.cpage--
              }
              await this.getList(this.paginationOptions)
            }
          })
          .catch((err) => { })
      }
      if (item.type == "resetPassword") {
        this.$myConfirm({
          content: this.$t("message_Confirm_that_the_password_is_reset"),
        })
          .then(async () => {
            const reset = await mrc_admin_reset({
              uuid: obj.uuid,
              login_url: this.$store.state.loginUrl,
            })
            if (reset.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
              await this.getList(this.paginationOptions)
            }
          })
          .catch(() => { })
      }
    },
    async getList (obj) {
      this.loading = true
      const { cpage, pagesize } = obj
      this.paginationOptions = { ...this.paginationOptions, ...obj }
      const res = await admin_account_list({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        org_level_uuid: this.$store.state.currentCompany,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if ((res.code = 200)) {
        this.items = res.data
        // this.$set(this.paginationOptions, 'totalcount', res.totalcount)
        // this.$set(this.paginationOptions, 'totalpage', res.totalpage)
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
      }
      this.loading = false
    },
  },
}
</script>

<style scoped></style>
